import { render, staticRenderFns } from "./AdminBar.vue?vue&type=template&id=4d5e4458&"
import script from "./AdminBar.vue?vue&type=script&lang=js&"
export * from "./AdminBar.vue?vue&type=script&lang=js&"
import style0 from "./AdminBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports